/**
 * @file /auth route definitions.
 */
import React from 'react';

import RequireAuth from '../components/routing/RequireAuth';
import RequireUnauth from '../components/routing/RequireUnauth';
import LoginView from '../views/auth/LoginView';
import AccountSetupView from '../views/auth/AccountSetupView';
import RegisterView from '../views/auth/RegisterView';
import PasswordResetView from '../views/auth/PasswordResetView/PasswordResetView';
import EmailVerifyView from '../views/auth/EmailVerifyView';
import PhoneAuthView from '../views/auth/PhoneAuthView';
import EmailVerificationNoticeView from '../views/auth/EmailVerificationNoticeView';
import EmailAuthLinkResolver from '../apps/auth/components/EmailAuthLinkResolver';
import PasswordSetup from '../apps/shutterbug/views/PasswordSetup';
import { OAUTH_PROVIDERS } from '../constants/oauth';
import OAuthLogin from '../apps/shutterbug/views/OAuthLogin';
import RegisterAppSumo from '../views/auth/RegisterAppSumo';
import OnboardingAuthView from '../views/auth/OnboardingAuthView';

const routes = [
  {
    path: '/auth/phone',
    exact: true,
    // TODO: Add `RequireUnauth` back when we can safely update phone numbers.
    // This does not `RequireUnauth` simply because we need
    // to redirect here authenticated users that do not have mobile numbers yet
    // i.e. registered via email (from Web Galleries upsell modal i.e.
    // `WebGalleryUpsellModal` or other means, i.e. logging in via pro and
    // then coming back). We'll keep it like this until we have
    // the ability to safely update phone numbers.
    component: PhoneAuthView,
  },
  {
    path: '/auth/onboarding',
    exact: true,
    component: OnboardingAuthView,
  },
  {
    path: '/auth/login',
    exact: true,
    component: RequireUnauth(LoginView),
  },
  {
    path: '/auth/register',
    exact: true,
    component: RequireUnauth(RegisterView),
  },
  {
    path: '/register/appsumo',
    exact: true,
    component: RequireUnauth(RegisterAppSumo),
  },
  {
    path: '/auth/password/reset',
    exact: true,
    component: RequireUnauth(PasswordResetView),
  },
  {
    path: '/auth/email/verification',
    exact: true,
    component: RequireAuth(EmailVerifyView, {
      redirectUrl: `/shutterbug/signin?defaultUserMode=PRO`,
    }),
  },
  {
    path: '/auth/account-setup',
    exact: true,
    component: RequireAuth(AccountSetupView),
  },
  {
    path: '/auth/email/request-verification',
    exact: true,
    component: RequireAuth(EmailVerificationNoticeView),
  },
  {
    path: '/auth/email-redirect',
    exact: true,
    component: EmailAuthLinkResolver,
  },
  {
    path: '/auth/password-setup',
    exact: true,
    component: RequireAuth(PasswordSetup),
  },
  {
    path: '/auth/blackbaud/callback',
    exact: true,
    component: () => <OAuthLogin provider={OAUTH_PROVIDERS.BLACKBAUD} />,
  },
];

export default routes;
